export default function Header() {

    return (
        <div className="in-page__hero">
            <div>
                <div className="page-bg after:bg-publishers-hero">
                    <h1 className="hero__title">Publishers</h1>
                    <p className="section-desc white">The Pixad panel displays data in real-time. Our technology, developed with artificial intelligence, publishes safe advertisements that protect advertisers and also boost revenues for publishers' websites.</p>
                </div>
            </div>
        </div>
    )
}